// extracted by mini-css-extract-plugin
module.exports = {"list":"IntervalStatusBadges_list__2jCnq","root":"IntervalStatusBadges_root__1PXAk","blockTitle":"IntervalStatusBadges_blockTitle__15KBr"};